module.exports = __webpack_public_path__ + "img/sisadmin.ecbd6dc1.svg";